export enum TicketContactType {
  AUTHOR = 'AUTHOR',
  ASSIGNEE = 'ASSIGNEE',
  WATCHER = 'WATCHER',
  PARTICIPANT = 'PARTICIPANT',
}
